import n from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: a = 16, useVw: e, useRem: l, color: o, withColor: c, removeClassName: t, disableSSR: p, style: i, ...g }) => {
  const m = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ n.createElement(h, { disableSSR: p }, /* @__PURE__ */ n.createElement("svg", { "data-icon-id": "24px-lianghuagendan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: e ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), height: e ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: m, fill: "none", ...g }, /* @__PURE__ */ n.createElement(
    "g",
    {
      className: t ? "" : "24px-éåè·å"
    },
    /* @__PURE__ */ n.createElement(
      "path",
      {
        className: t ? "" : "normal",
        d: "M11.624 2.082a3.167 3.167 0 0 0-3.573 3.141v13.554a3.167 3.167 0 0 0 3.573 3.14l7.488-.966a3.167 3.167 0 0 0 2.762-3.141v-3.048a.8.8 0 0 0-1.6 0v3.048c0 .788-.585 1.453-1.367 1.554l-7.488.967a1.567 1.567 0 0 1-1.768-1.554V5.223c0-.945.831-1.675 1.768-1.554l7.488.967c.782.1 1.367.766 1.367 1.554V8.6a.778.778 0 0 1-.22.54l-3.181 3.288-2.1-2.168a.8.8 0 0 0-1.221.086l-2.292 3.157a.8.8 0 1 0 1.295.94l1.732-2.386 2.01 2.078a.8.8 0 0 0 1.15 0l3.758-3.881a2.381 2.381 0 0 0 .669-1.655V6.19a3.167 3.167 0 0 0-2.762-3.14l-7.488-.968ZM5.292 4.887a3.167 3.167 0 0 0-3.167 3.168v7.89a3.167 3.167 0 0 0 3.167 3.168h.433a.8.8 0 0 0 0-1.6h-.433a1.567 1.567 0 0 1-1.567-1.568v-7.89c0-.866.702-1.568 1.567-1.568h.433a.8.8 0 1 0 0-1.6h-.433Z",
        fill: c ? r(o, 0, "#262933") : "#262933",
        datafollowfill: c ? r(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, E = x;
export {
  E as default
};
